/**
 * Given a string of YAML, finds all nested blocks of YAML under `style:` or `styles:`
 *
 * Run `npm test` for unit tests.
 *
 * @example
 * ```ts
 * const yaml = `
 * - foo: 1
 *   style: m-2 p-4 bg-red-500
 *   bar:
 *     - styles:
 *         title: p-4
 *         text: bg-red-500
 *   baz: 2
 * `;
 *
 * const styles = extractTailwindStyles(yaml);
 * // styles === 'm-2 p-4 bg-red-500 p-4 bg-red-500'
 *
 * ```
 *
 * @param str
 */
export default function extractTailwindStyles(str: string) {
  // loop through every character in the string
  // note each '\n' character and count leading spaces including '-' characters
  // a line that starts with 'style:' or 'styles:' begins a "style block"
  // the block continues as long as the following lines have more leading spaces than the start of the block.
  // store all the blocks in a new string and return it
  let styles = '';
  let inStyleBlock = false;
  let maybeStartingStyleBlock = false;
  let countingSpaces = false;
  let spaceCount = 0;
  let spaceCountOfStyleBlick = 0;

  for (let i = 0; i < str.length; i++) {
    if (str[i] === '\n') {
      countingSpaces = true;
      spaceCount = 0;
      if (inStyleBlock) styles += ' ';
      continue;
    }

    if (countingSpaces) {
      if (str[i] === ' ' || str[i] === '-') {
        spaceCount++;
        continue;
      } else {
        countingSpaces = false;

        if (inStyleBlock && spaceCount <= spaceCountOfStyleBlick) {
          inStyleBlock = false;
        }

        maybeStartingStyleBlock = true;
      }
    }

    if (inStyleBlock) {
      styles += str[i];
    }

    if (maybeStartingStyleBlock) {
      if (str[i] === 's') {
        if (str.slice(i, i + 6) === 'style:') {
          inStyleBlock = true;
          styles += ' ';
          spaceCountOfStyleBlick = spaceCount;
          maybeStartingStyleBlock = false;
          i += 6;
          continue;
        }

        if (str.slice(i, i + 7) === 'styles:') {
          inStyleBlock = true;
          styles += ' ';
          spaceCountOfStyleBlick = spaceCount;
          maybeStartingStyleBlock = false;
          i += 7;
          continue;
        }
      }

      // if (str[i] === '-' || str[i] === ' ') {
      //   continue;
      // }

      maybeStartingStyleBlock = false;
    }
  }

  return styles;
}
